import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.global.useDownloadAuditReportCollectionData', {
    auditReportErrorAccessDenied: 'Sorry, you have no access to this resource.',
});
